const source = document.getElementById('vd-selection-products');
const badgeTemplate = document.getElementById('vd-selection-template');
const sampleTemplate = document.getElementById('vd-cart-sample-template');
if (source && badgeTemplate) {
  const selected = new Set(JSON.parse(source.textContent).map(item => String(item.id)));
  let sequence = 0;
  const addBadge = host => {
    if (!host || host.querySelector(':scope > .vd-selection')) return;
    const badge = badgeTemplate.content.firstElementChild.cloneNode(true);
    const button = badge.querySelector('button');
    const tooltip = badge.querySelector('.vd-selection__tooltip');
    tooltip.id = `vd-selection-tooltip-${++sequence}`;
    button.setAttribute('aria-controls', tooltip.id);
    host.classList.add('vd-pick-host');
    host.append(badge);
    if (host.getBoundingClientRect().left > window.innerWidth / 2) badge.classList.add('vd-selection--right');
    button.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      const open = !badge.hasAttribute('data-open');
      document.querySelectorAll('.vd-selection[data-open]').forEach(other => {
        other.removeAttribute('data-open');
        other.querySelector('button').setAttribute('aria-expanded', 'false');
      });
      badge.toggleAttribute('data-open', open);
      button.setAttribute('aria-expanded', String(open));
    });
    badge.addEventListener('click', event => event.stopPropagation());
  };
  const decorate = () => {
    const groups = new Map();
    document.querySelectorAll('product-card[data-product-id]').forEach(card => {
      const group = card.closest('.product-grid, .section-resource-list, .product-recommendations, results-list, .shopify-section') || card.parentElement;
      if (!groups.has(group)) groups.set(group, []);
      groups.get(group).push(card);
    });
    groups.forEach(cards => {
      let lastBadgeIndex = -2;
      cards.forEach((card, index) => {
        const host = card.querySelector('.product-card__content');
        const eligible = selected.has(card.dataset.productId) && index - lastBadgeIndex >= 2;
        if (!eligible) {
          host?.querySelector(':scope > .vd-selection')?.remove();
          host?.querySelector(':scope > .vd-cart-sample')?.remove();
          return;
        }
        lastBadgeIndex = index;
        addBadge(host);
        if (host && sampleTemplate && !host.querySelector('.vd-cart-sample')) host.append(sampleTemplate.content.firstElementChild.cloneNode(true));
      });
    });
    const mainGallery = document.querySelector('main media-gallery');
    const price = Array.from(document.querySelectorAll('main product-price[data-product-id]')).find(node => !node.closest('product-card'));
    if (mainGallery && price && selected.has(price.dataset.productId)) {
      addBadge(mainGallery);
      if (sampleTemplate && !price.previousElementSibling?.classList.contains('vd-cart-sample')) {
        const sample = sampleTemplate.content.firstElementChild.cloneNode(true);
        sample.classList.add('vd-cart-sample--detail');
        price.before(sample);
      }
    }
  };
  decorate();
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; decorate(); });
  }).observe(document.querySelector('main') || document.body, {childList:true, subtree:true});
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.vd-selection[data-open]').forEach(badge => {
      badge.removeAttribute('data-open');
      badge.querySelector('button').setAttribute('aria-expanded', 'false');
      badge.querySelector('button').blur();
    });
  });
  document.addEventListener('click', event => {
    if (event.target.closest('.vd-selection')) return;
    document.querySelectorAll('.vd-selection[data-open]').forEach(badge => {
      badge.removeAttribute('data-open');
      badge.querySelector('button').setAttribute('aria-expanded', 'false');
    });
  });
}


